import { getAuth, signOut } from "firebase/auth";

export default {
    namespaced: true,
    
    state: {},
    mutations: {},
    
    actions: {
        async logout(context) {
            const auth = getAuth();
            try {
                await signOut(auth);
                localStorage.removeItem("user");
                context.commit('logout', null, {root: true});
            } catch(error) {
                console.error(error)
            }
        }
    },

    getters: {},
}